import { Circle } from 'fabric';
import { lineControlStyles } from '@/config/options';

const makeCurvePoint = (left: number, top: number, isMobile: boolean): Circle =>
  new Circle({
    left: left,
    top: top,
    ...lineControlStyles,
    // the control circles should not get the fabric editors
    width: isMobile ? 32 : 8,
    height: isMobile ? 32 : 8,
    radius: 6,
    hasBorders: true,
    hasControls: false,
    selectable: true,
    objectCaching: true,
    originX: 'center',
    originY: 'center',
  });

export default makeCurvePoint;
